import React from "react";
import "../../assets/css/PopUpMessage.css";

const PopupMessage = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <p>{message}</p>
        <button onClick={onClose} className="popup-btn">
          OK
        </button>
      </div>
    </div>
  );
};

export default PopupMessage;